export default __webpack_public_path__ + "static/media/avatar.5041e498.svg";